module.exports = __webpack_public_path__ + "static/media/tablet-portrait.087944e6.svg";